import { useDestination } from '../../../containers/destination/hooks/useDestination';

export function useDataSource({ dataSourceId }) {
  const {
    rawDestination,
    destinationUIState,
    getDestination,
    onSchemaDelete,
    refetchDestination
  } = useDestination({ destinationId: dataSourceId });

  return {
    dataSource: rawDestination,
    dataSourceUIState: destinationUIState,
    getDataSource: getDestination,
    onSchemaDelete: onSchemaDelete,
    refetchDataSource: refetchDestination
  };
}
